import { makeStyles } from '@material-ui/core/styles';

type StylesProps = {
  isStuck: boolean;
};

const useStyles = makeStyles(theme => ({
  fileTypeSelector: {
    display: 'flex',
    width: '100%',
  },
  fileTypeButtonGroup: {
    display: 'flex',
    width: '100%',
    flexWrap: 'nowrap',
  },
  fileTypeButton: {
    flex: '1 1 0',
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      fontSize: '.85rem',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  tile: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    flexGrow: 1,
    transformOrigin: 'top right',
    transition: '.3s ease',
    justifyContent: 'space-between',
    transform: ({ isStuck }: StylesProps) => (isStuck ? 'scale(0)' : 'scale(1)'),
    opacity: ({ isStuck }: StylesProps) => (isStuck ? 0.7 : 1),
    '& p': {
      color: theme.palette.grey['800'],
      textAlign: 'center',
    },
  },
  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  navigationButtons: {
    display: 'grid',
    gridTemplateColumns: '28px 1fr 28px',
    alignItems: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(1),
    },
  },
}));

export default useStyles;
